import { KOZYCLANLOGO } from "../../assets/index";
import { Box, Button } from "@mui/material";
import { Link } from "react-router";


const HomeScreen = () => {
  return (
    <Box
      display="flex"
      alignItems="center"
      justifyContent="center"
      height="100vh"
      flexDirection="column"
    >
      <img src={KOZYCLANLOGO} />
      {/* <Box display="flex" columnGap={4}>
        <Link to="./signIn">
          <Button sx={{width: 150}} variant="contained">Sign In</Button>
        </Link>
        <Link to="./signUp">
          <Button sx={{width: 150}} variant="contained">Sign Up</Button>
        </Link>
      </Box> */}
    </Box>
  );
};

export default HomeScreen;
